









































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import { EventBus } from "../lib/EventBus";
import { Autorisatie } from "../Autorisatie";

interface ChangePasswordViewModel {
  OldPassword: string;
  NewPassword: string;
  ConfirmNewPassword: string;
}

export default Vue.extend({
  data() {
    return {
      attempt: 0,
      model: {
        OldPassword: "",
        NewPassword: "",
        ConfirmNewPassword: ""
      },
      isVerifying: false
    };
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy: function() {
    document.removeEventListener("keydown", this.onKeydown);
  },

  computed: {
    passwordState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.model.OldPassword ? null : false;
      }
      return null;
    },
    passwordNewState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.model.NewPassword ? null : false;
      }
      return null;
    },
    passwordConfirmState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.model.ConfirmNewPassword
          ? this.model.ConfirmNewPassword === this.model.NewPassword
            ? null
            : false
          : false;
      }
      return null;
    }
  },
  methods: {
    onKeydown(e: any) {
      const escape = 27;
      const enter = 13;
      const arrowUp = 38;
      const arrowDown = 40;

      switch (e.keyCode) {
        case enter:
          this.doSubmit();
          break;
      }
    },
    doSubmit() {
      this.attempt++;
      if (
        !this.isVerifying &&
        !!this.model.OldPassword &&
        !!this.model.NewPassword &&
        !!this.model.ConfirmNewPassword &&
        this.model.ConfirmNewPassword === this.model.NewPassword
      ) {
        this.isVerifying = true;

        const settings = this.model;

        axios
          .put("/api/backend/v1/users/changepassword", settings, {
            headers: { "Content-Type": "application/json" }
          })
          .then(response => {
            setTimeout(() => {
              this.isVerifying = false;
            }, 500);
            this.$router.push({ name: "logout" });
          })
          .catch(error => {
            if (
              !!error.response &&
              !!error.response.data &&
              !!error.response.data.Message
            ) {
              let msg = `${this.$i18n.t("generalerror")}`;
              const errorcode = error.response.data.Message;
              switch (errorcode) {
                case "1000":
                  msg = `${this.$i18n.t("invalidinput")}`;
                  break;
                case "1001":
                  msg = `${this.$i18n.t("uniqueInput")}`;
                  break;
                case "1002":
                  msg = `${this.$i18n.t("passwordTooShort")}`;
                  break;
                case "1003":
                  msg = `${this.$i18n.t("passwordTooWeak")}`;
                  break;
                case "1004":
                  msg = `${this.$i18n.t("emailInvalid")}`;
                  break;
                case "1005":
                  msg = `${this.$i18n.t("passwordIncorrect")}`;
                  break;
                case "1006":
                  msg = `${this.$i18n.t("passwordInequal")}`;
                  break;
                default:
                  break;
              }

              if (!!msg) {
                EventBus.$emit("add-toastr", {
                  text: msg,
                  type: "error"
                });
              }
            }
            this.isVerifying = false;
          });
      }
    }
  }
});
